export default "__VITE_ASSET__B6pAsM3D__"